import React from "react";
import contextProvider from "../../contextProvider";
import { withRouter, Link } from "react-router-dom";
import { Row, Col } from "reactstrap";
import classnames from "classnames";

import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";

import ReactOTableForceOrder from "../../_L1_components/Elements/ReactOTableForceOrder";

class MeasuresOveralsList extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: {},
    };
    super(props, initState);
    this.showBSSIDs = true;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    // console.log("this props", this.props);
    this.apiStore = this.getAppContext().getApiStoreService();
    if (this.getAppContext().platformName()) {
      this.getAppContext().platformName() === "WiFiProbe"
        ? (this.showBSSIDs = true)
        : (this.showBSSIDs = false);
    }
  }

  onComponentWillUnmount() {
    //		console.log("DEBUG :: MeasuresOveralsList _ onComponentWillUnmount");
  }

  onRender() {
    return (
      <ReactOTableForceOrder
        thClassName="px-3 py-1"
        tdClassName="align-middle px-3 py-2"
        hoverable
        compressed={
          this.getAppContext().media.isMobile ||
          this.getAppContext().media.isTablet
        }
        compressedRowRendering={(row_items, link) => {
          return (
            <div>
              {link ? (
                <Link className="link-table-test" to={link} target="_blank">
                  <div>
                    <div className="text-center">
                      {row_items?.graph_image?.content}
                    </div>
                    <div className="mt-1">{row_items?.info?.content}</div>
                    <div className="mt-1">
                      <div className="text-muted">
                        <small className="">
                          <strong>{row_items?.essid?.title}</strong>
                        </small>
                      </div>
                      {row_items?.essid?.content}
                    </div>
                    <Row className="mt-1">
                      <Col>
                        <div className="text-muted">
                          <small className="">
                            <strong>
                              {row_items &&
                                row_items.bssid_count &&
                                row_items.bssid_count.title &&
                                row_items.bssid_count.title}
                            </strong>
                          </small>
                        </div>
                        {row_items?.bssid_count?.content}
                      </Col>
                      <Col>
                        <div className="text-muted">
                          <small className="">
                            <strong>{row_items?.score?.title}</strong>
                          </small>
                        </div>
                        {row_items?.score?.content}
                      </Col>
                      <Col>
                        <div className="text-muted">
                          <small className="">
                            <strong>{row_items?.status?.title}</strong>
                          </small>
                        </div>
                        {row_items?.status?.content}
                      </Col>
                    </Row>
                  </div>
                </Link>
              ) : (
                <div>
                  <div className="text-center">
                    {row_items?.graph_image?.content}
                  </div>
                  <div className="mt-1">{row_items?.info?.content}</div>
                  <div className="mt-1">
                    <div className="text-muted">
                      <small className="">
                        <strong>{row_items?.essid?.title}</strong>
                      </small>
                    </div>
                    {row_items?.essid?.content}
                  </div>
                  <Row className="mt-1">
                    <Col>
                      <div className="text-muted">
                        <small className="">
                          <strong>{row_items?.bssid_count?.title}</strong>
                        </small>
                      </div>
                      {row_items?.bssid_count?.content}
                    </Col>
                    <Col>
                      <div className="text-muted">
                        <small className="">
                          <strong>{row_items?.score?.title}</strong>
                        </small>
                      </div>
                      {row_items?.score?.content}
                    </Col>
                    <Col>
                      <div className="text-muted">
                        <small className="">
                          <strong>{row_items?.status?.title}</strong>
                        </small>
                      </div>
                      {row_items?.status?.content}
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          );
        }}
        thDividers
        cachedPosition
        defaultSort={[
          {
            data_key: "info",
            order: "asc",
          },
        ]}
        // onRowClick={(row_data) => {
        //   this.getAppContext().redirectTo(
        //     "/" +
        //       this.props.match.params.probeuid +
        //       "/" +
        //       this.props.match.params.status +
        //       "/" +
        //       row_data.cssid
        //   );
        // }}
        onRowClick={
          this.props.onItemClick
            ? this.props.onItemClick
            : (row_data) => {
                console.log(row_data);
              }
        }
        cols={
          this.showBSSIDs == true
            ? [
                {
                  title: "MEASURE",
                  data_key: "info",
                  width: "30",
                  sortable: true,
                },
                {
                  title: "GRAPH",
                  align: "center",
                  data_key: "graph_image",
                  width: "20",
                },
                {
                  title: "BSSIDs",
                  align: "center",
                  data_key: "bssid_count",
                  width: "5",
                },
                {
                  title: "NETWORK",
                  align: "center",
                  data_key: "essid",
                  width: "15",
                  sortable: true,
                },
                {
                  title: "SCORE",
                  align: "center",
                  data_key: "score",
                  width: "5",
                  sortable: true,
                },
                {
                  title: <span>STATUS</span>,
                  align: "center",
                  data_key: "status",
                  width: "15",
                },
              ]
            : [
                {
                  title: "MEASURE",
                  data_key: "info",
                  width: "30",
                  sortable: true,
                },
                {
                  title: "GRAPH",
                  align: "center",
                  data_key: "graph_image",
                  width: "20",
                },
                {
                  title: "NETWORK",
                  align: "center",
                  data_key: "essid",
                  width: "15",
                  sortable: true,
                },
                {
                  title: "SCORE",
                  align: "center",
                  data_key: "score",
                  width: "5",
                  sortable: true,
                },
                {
                  title: <span>STATUS</span>,
                  align: "center",
                  data_key: "status",
                  width: "15",
                },
              ]
        }
        rows={(() => {
          let _TMP = (this.props.data ? this.props.data : [])
            .sort()
            // .filter((elem) => {
            //   return elem.paused != null;
            // })
            .map((_CURR_measure, _CURR_idx) => {
              let pathname =
                "/" +
                this.props.match.params.probeuid +
                "/" +
                (_CURR_measure.archived
                  ? "archived"
                  : _CURR_measure.paused
                  ? "paused"
                  : "active") +
                "/" +
                _CURR_measure.cssid;
              return {
                _link: {
                  pathname,
                  state: {
                    mlist: this.props.mlist,
                    cssids: this.props.cssids,
                    selectedTags: this.props.selectedTags,
                  },
                },
                cssid: _CURR_measure.cssid,

                info: {
                  value: _CURR_measure.name,
                  render: (
                    <small>
                      <Row className="mb-1">
                        <Col xs={12}>
                          <h5>{_CURR_measure.name}</h5>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <strong className="text-muted">
                            CONNECTION CRITERIA
                          </strong>
                          <br />
                          <div className="">
                            {typeof _CURR_measure.connection_criteria ==
                            "object" ? (
                              Object.keys(_CURR_measure.connection_criteria)
                                .sort()
                                .map((_C_bssid, _C_idx) => {
                                  return (
                                    <div key={_C_idx}>
                                      <strong>
                                        {_CURR_measure.connection_criteria[
                                          _C_bssid
                                        ] ? (
                                          <span>
                                            {_CURR_measure.connection_criteria[
                                              _C_bssid
                                            ].ap_custom_data
                                              ? _CURR_measure
                                                  .connection_criteria[_C_bssid]
                                                  .ap_custom_data.name
                                              : _CURR_measure
                                                  .connection_criteria[_C_bssid]
                                                  .short_desc}
                                          </span>
                                        ) : null}
                                      </strong>
                                      <br />
                                      <span className="text-muted">
                                        ({_C_bssid})
                                      </span>
                                    </div>
                                  );
                                })
                            ) : (
                              <strong>
                                {_CURR_measure.connection_criteria
                                  .split(" ")
                                  .map((_C_value, _C_idx) => {
                                    return <div key={_C_idx}>{_C_value}</div>;
                                  })}
                              </strong>
                            )}
                          </div>
                        </Col>
                        <Col>
                          <strong className="text-muted">TEST</strong>
                          <br />
                          <strong className="">{_CURR_measure.test}</strong>
                        </Col>
                      </Row>
                    </small>
                  ),
                },

                graph_image: _CURR_measure.overalData.ImgName ? (
                  <img
                    src={
                      this.getAppContext().getApiStoreService().getCluster() +
                      "/RRDgrcache/" +
                      _CURR_measure.overalData.ImgName
                    }
                    className="border border-1 rounded"
                    alt="graph"
                  />
                ) : (
                  <span>...</span>
                ),

                bssid_count: /ethernet/i.test(_CURR_measure.essid)
                  ? "-"
                  : _CURR_measure.bssidsCount,

                essid: {
                  value: _CURR_measure.essid,
                  render: _CURR_measure.essid,
                },

                score: {
                  value: _CURR_measure.overalData.score,
                  render: (
                    <strong
                      className={classnames({
                        "text-success": _CURR_measure.overalData.score >= 80,
                        "text-orange":
                          _CURR_measure.overalData.score >= 60 &&
                          _CURR_measure.overalData.score < 80,
                        "text-danger": _CURR_measure.overalData.score < 60,
                      })}
                    >
                      {_CURR_measure.overalData.score !== undefined
                        ? _CURR_measure.overalData.score
                        : "--"}
                    </strong>
                  ),
                },

                status: (() => {
                  let _label = _CURR_measure.archived ? (
                    <div>
                      <span className="icon-archive mr-2" />
                      Archived
                      <div className="sub-title">
                        (
                        {this.getAppContext()
                          .momentjs(_CURR_measure.archived, "X")
                          .format("L LT")}
                        )
                      </div>
                    </div>
                  ) : _CURR_measure.paused ? (
                    <div className="text-orange">
                      <span className="icon-pause mr-2" />
                      Paused
                      <div className="sub-title">
                        (
                        {this.getAppContext()
                          .momentjs(_CURR_measure.paused, "X")
                          .format("L LT")}
                        )
                      </div>
                    </div>
                  ) : (
                    <div className="text-success">Running</div>
                  );
                  return {
                    value: _CURR_measure.archived
                      ? 2
                      : _CURR_measure.paused
                      ? 1
                      : 0,
                    render: _label,
                  };
                })(),
              };
            });
          return _TMP;
        })()}
      />
    );
  }
}

export default contextProvider(withRouter(MeasuresOveralsList), {
  define: null,
});
